import { render, staticRenderFns } from "./MenuAssign.vue?vue&type=template&id=03150ba4&scoped=true&"
import script from "./MenuAssign.vue?vue&type=script&lang=js&"
export * from "./MenuAssign.vue?vue&type=script&lang=js&"
import style0 from "./MenuAssign.vue?vue&type=style&index=0&id=03150ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03150ba4",
  null
  
)

export default component.exports